import { Component, OnInit, Inject } from '@angular/core';
import {
	MatDialogRef,
	MatDialogConfig,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
	FormGroup,
	FormControl,
	FormBuilder,
	Validators,
} from '@angular/forms';
import { forkJoin } from 'rxjs';
import { Store } from '@ngrx/store';
import {
	RecursosService,
	ResourceWithValidations,
} from '../../modules/recursos/services/recursos.service';
import { ResourceCategory } from '../../interfaces/recursos/resource-category.entity';
import { ApplicationStore } from '../../shared/state/store/index';
import { loadingAction } from '../../shared/state/actions/loading.action';
import { showAlert } from '../../utils/alert';

type NewResourceData = {
	defaultValue: string | undefined;
	resourceToEdit: ResourceWithValidations | undefined;
};

@Component({
	selector: 'app-new-resource',
	templateUrl: './new-resource.component.html',
	styleUrls: ['./new-resource.component.scss'],
})
export class NewResourceComponent implements OnInit {
	static defaultConfig: MatDialogConfig<NewResourceData> = {
		width: '80rem',
		autoFocus: false,
		closeOnNavigation: false,
		disableClose: true,
	};

	resourceForm: FormGroup = this.fb.group({
		name: new FormControl('', [Validators.required]),
		description: new FormControl(''),
		category: new FormControl('', [Validators.required]),
	});
	categoriesList: ResourceCategory[] = [];

	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<NewResourceComponent>,
		private recursosService: RecursosService,
		private store: Store<ApplicationStore>,
		@Inject(MAT_DIALOG_DATA) public data: NewResourceData,
	) {}

	ngOnInit(): void {
		forkJoin({
			categories: this.recursosService.getCategories(),
		}).subscribe(({ categories }) => {
			this.categoriesList = categories;

			// Edit resource
			if (this.data.resourceToEdit) {
				this.resourceForm.reset({
					name: this.data.resourceToEdit.name.toUpperCase(),
					description: this.data.resourceToEdit.description,
					category: this.data.resourceToEdit.category?.id,
				});
			}

			if (this.data.defaultValue) {
				this.resourceForm.reset({
					name: this.data.defaultValue ?? '',
				});
			}
		});
	}

	saveResource() {
		if (this.resourceForm.valid) {
			this.resourceForm.value.name = this.resourceForm.value.name.toUpperCase();
			this.store.dispatch(loadingAction({ loading: true }));

			if (this.data.resourceToEdit) {
				this.recursosService
					.updateResource(this.data.resourceToEdit.id, this.resourceForm.value)
					.subscribe((resource) => {
						this.store.dispatch(loadingAction({ loading: false }));

						showAlert('Recurso modificado', () => {
							this.dialogRef.close({
								...this.data.resourceToEdit,
								name: resource.name.toUpperCase(),
								description: resource.description,
								category: resource.category,
							});
						});
					});
			} else {
				this.recursosService
					.createResource(this.resourceForm.value)
					.subscribe((resource) => {
						this.store.dispatch(loadingAction({ loading: false }));

						showAlert('Recurso creado', () => {
							this.dialogRef.close(resource);
						});
					});
			}
		}
	}

	inputToUpperCase() {
		this.resourceForm.value.name = this.resourceForm.value.name.toUpperCase();
	}
}
